import {h, Fragment} from "preact"
export default function GridToggles({ mobileColumns, desktopColumns, changeGridColumns }) {

    return (
        <div className="ns-toolbar__controls-grid">
            <span aria-hidden="true">SHOW:</span>
            <fieldset className="ns-toolbar__controls-grid-options ns-mobile-toggles ns-p-0 ns-m-0">
                <legend className="visually-hidden sr-only">Select mobile products per row</legend>
                <label>
                    1
                    <input 
                        type="radio" 
                        className="visually-hidden" 
                        value="1" 
                        checked={(mobileColumns === "1")} 
                        onChange={changeGridColumns} 
                    />
                </label>
                <label>
                    2
                    <input 
                        type="radio" 
                        className="visually-hidden" 
                        value="2" 
                        checked={(mobileColumns === "2")} 
                        onChange={changeGridColumns} 
                    />
                </label>
            </fieldset>
            <fieldset className="ns-toolbar__controls-grid-options ns-desktop-toggles ns-p-0 ns-m-0">
                <legend className="visually-hidden sr-only">Select desktop products per row</legend>
                <label>
                    2
                    <input 
                        type="radio" 
                        className="visually-hidden" 
                        value="2" 
                        checked={(desktopColumns === "2")} 
                        onChange={changeGridColumns} 
                    />
                </label>
                <label>
                    4
                    <input 
                        type="radio"  
                        className="visually-hidden" 
                        value="4" 
                        checked={(desktopColumns === "4")} 
                        onChange={changeGridColumns} 
                    />
                </label>
            </fieldset>
        </div>
    )
}
